import { RtcStreamType } from "@formant/core/model/RtcStreamType";
import {
    rtcAudioChunkStreamType,
    rtcBooleanStreamType,
    rtcCompressedImageStreamType,
    rtcGoalIDStreamType,
    rtcH264VideoFrameStreamType,
    rtcJointStateStreamType,
    rtcJoyStreamType,
    rtcMarkerArrayStreamType,
    rtcNumericStreamType,
    rtcOdometryStreamType,
    rtcPointCloudStreamType,
    rtcPointStreamType,
    rtcPoseStreamType,
    rtcPoseWithCovarianceStreamType,
    rtcTextStreamType,
    rtcTwistStreamType,
} from "@formant/core/model/rtcStreamTypes";
import { TeleopRosTopicType } from "@formant/core/model/TeleopRosTopicType";

export function teleopRosTopicTypeToRtcStreamType(
    type: TeleopRosTopicType,
    encodeVideo: boolean | undefined,
): RtcStreamType {
    switch (type) {
        case "actionlib_msgs/GoalID":
            return rtcGoalIDStreamType;
        case "formant/H264VideoFrame":
            return rtcH264VideoFrameStreamType;
        case "geometry_msgs/PoseStamped":
            return rtcPoseStreamType;
        case "geometry_msgs/Twist":
            return rtcTwistStreamType;
        case "sensor_msgs/CompressedImage":
            return encodeVideo
                ? rtcH264VideoFrameStreamType
                : rtcCompressedImageStreamType;
        case "std_msgs/Float64":
            return rtcNumericStreamType;
        case "std_msgs/Float32":
            return rtcNumericStreamType;
        case "std_msgs/Bool":
            return rtcBooleanStreamType;
        case "std_msgs/String":
            return rtcTextStreamType;
        case "audio_common_msgs/AudioData":
            return rtcAudioChunkStreamType;
        case "sensor_msgs/JointState":
            return rtcJointStateStreamType;
        case "geometry_msgs/PoseWithCovarianceStamped":
            return rtcPoseWithCovarianceStreamType;
        case "sensor_msgs/LaserScan":
        case "sensor_msgs/PointCloud2":
            return rtcPointCloudStreamType;
        case "geometry_msgs/PointStamped":
            return rtcPointStreamType;
        case "visualization_msgs/MarkerArray":
            return rtcMarkerArrayStreamType;
        case "nav_msgs/Odometry":
            return rtcOdometryStreamType;
        case "sensor_msgs/Joy":
            return rtcJoyStreamType;
        default:
            throw Error(
                `Attempted to convert ROS topic type without a corresponding RTC type ${type}`,
            );
    }
}
